"use strict";
/*
  PNG parsing library with metadata reading/writing functionality. Copyright (C) 2020-2021 Vereign AG

  This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General
  Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option)
  any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied
  warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
  details.

  You should have received a copy of the GNU Affero General Public License along with this program. If not, see
  https://www.gnu.org/licenses/.

  In case of queries or questions, please contact us under by email under contact@vereign.com or by letter post to
  Vereign AG, Kolinplatz 10, 6300 Zug, Switzerland
*/
Object.defineProperty(exports, "__esModule", { value: true });
const Chunk_1 = require("./Chunk");
const PNG_HEADER = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
class PNG {
    constructor() {
        this.chunks = [];
    }
    static readPng(data) {
        const png = new PNG();
        let offset = 8;
        for (let i = 0; i < 8; i++) {
            if (data[i] != PNG_HEADER[i]) {
                throw "The input is not a PNG file!";
            }
        }
        while (offset < data.length) {
            const { chunk, chunkLen } = Chunk_1.default.readChunk(data, offset);
            png.chunks.push(chunk);
            offset += chunkLen;
        }
        return png;
    }
    appendChunk(chunkType, data) {
        const chunk = new Chunk_1.default(chunkType, data);
        return this.appendExistingChunk(chunk);
    }
    appendExistingChunk(chunk) {
        this.chunks.push(chunk);
        return chunk;
    }
    insertChunk(pos, chunkType, data) {
        const chunk = new Chunk_1.default(chunkType, data);
        return this.insertExistingChunk(pos, chunk);
    }
    insertExistingChunk(pos, chunk) {
        this.chunks.splice(pos, 0, chunk);
        return chunk;
    }
    bytes() {
        const bytes = [];
        this.writeTo(bytes);
        return new Uint8Array(bytes);
    }
    writeTo(buffer) {
        for (let i = 0; i < PNG_HEADER.length; i++) {
            buffer.push(PNG_HEADER[i]);
        }
        for (let i = 0; i < this.chunks.length; i++) {
            const chunk = this.chunks[i];
            chunk.writeTo(buffer);
        }
    }
    deleteChunk(pos) {
        this.chunks.splice(pos, 1);
    }
    deleteChunks(chunkType) {
        let i = 0;
        for (let j = 0; j < this.chunks.length; j++) {
            const chunk = this.chunks[j];
            if (chunk.type != chunkType) {
                this.chunks[i] = chunk;
                i++;
            }
        }
        this.chunks.splice(i, this.chunks.length - i);
    }
    findChunks(chunkType) {
        const result = [];
        for (let j = 0; j < this.chunks.length; j++) {
            const chunk = this.chunks[j];
            if (chunk.type == chunkType) {
                result.push(chunk);
            }
        }
        return result;
    }
    findChunk(chunkType) {
        for (let j = 0; j < this.chunks.length; j++) {
            const chunk = this.chunks[j];
            if (chunk.type == chunkType) {
                return chunk;
            }
        }
        return null;
    }
}
exports.default = PNG;
